import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import CommonHeader from "../components/CommonHeader";
import ErrorBoundary from "../components/ErrorBoundary";
import CommandPaletteProvider from "../components/ui/CommandPaletteProvider";

const MainLayout = () => {
  const navigate = useNavigate();

  const handleAdminAction = (action) => {
    if (action === 'acls') {
      navigate('/admin/acls');
    } else if (action === 'specs') {
      navigate('/admin/specs');
    } else if (action === 'approval') {
      navigate('/quality-control');
    } else if (action === 'api-keys') {
      navigate('/admin/api-keys');
    } else if (action === 'stats') {
      navigate('/admin/stats');
    } else if (action === 'retention-policies') {
      navigate('/admin/retention-policies');
    } else if (action === 'index') {
      navigate('/admin/index');
    }
  };

  const handleLogout = () => {
    // Aquí se puede agregar lógica de logout si es necesario
    console.log('Logout requested');
  };

  return (
    <CommandPaletteProvider>
      <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
        <CommonHeader onAdminAction={handleAdminAction} onLogout={handleLogout} />
        <div style={{ flex: 1 }}>
          <ErrorBoundary
            fallbackTitle="Error al cargar la página"
            fallbackMessage="Ocurrió un error al renderizar el contenido de esta página. El header sigue disponible para navegar."
          >
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </CommandPaletteProvider>
  );
};

export default MainLayout;
